<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"> <i class="fas fa-bell text-primary"></i> Notifications </h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label"> Title<sup><span class="text-danger font-12">*</span></sup> : </label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Title" />
        </div>
        <div class="col-md-3">
          <label class="form-label"> Message<sup><span class="text-danger font-12">*</span></sup> : </label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Message" />
        </div>
        <div class="col-md-3">
          <label class="form-label"> Menu<sup><span class="text-danger font-12">*</span></sup> : </label>
          <div class="dropdown">
            <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
              {{ menus.find(m => m.value === Obj.Menu)?.name || " " }}
            </button>
            <ul class="dropdown-menu w-100 scrollable-menu">
              <li v-for="(item, index) in menus" :key="index">
                <a class="dropdown-item" href="#" @click.prevent="Obj.Menu = item.value" >
                  {{ item.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-9 text-end mt-1">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()"> <i class="fa fa-save"></i> Save </button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"> <i class="fa fa-times-circle me-1"></i>Cancel </button>
        </div>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
        <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
      </ul>
      <div class="row">
        <div class="col-md-12 table-responsive mt-2">
          <div class="progress mb-0 progress-sm" v-if="progress != 0">
            <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100" :style="{ width: progress + '%' }" ></div>
          </div>
          <DataTable v-if="progress == 0" :columns="cols" :rows="rows" :pageSize="10" :actions="{ edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.Title" @delRecord="delRecord" @closeModal="delObj.Title = ''" ></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import { curdStatus, api } from "@/utils/helpers.js";
import { ref, onMounted } from "vue";

const Obj = ref({ Title: "", Message: "", Menu: "" });
const msgObj = ref({ msg: "", role: "", show: false });
const delObj = ref({});
const errors = ref({});
const menus = ref([]);

const cols = ref([
  { label: "S.No", key: "Sno" }, 
  { label: "Title", key: "Title" },
  { label: "Message", key: "Message" },
  { label: "Menu", key: "MenuName" },
  { label: "Status", key: "status", type: 'notify' },
]);

const handleEdit = (row) => {
  Obj.value = { ...row };
};

const handleDelete = (row) => {
  delObj.value = { ...row };
};

const rows = ref([]);
const loadmenus = async () => {
  try {
    const response = await api.get(`/menus/all`);
    menus.value = response.data.filter(item => {
      const val = item.value.toLowerCase();
      const isStudentPage = val.startsWith("/student/");
      const isBlocked =
        val.includes("teacher/add") ||
        val.includes("students/add") 
      return isStudentPage && !isBlocked;
    });
  } catch (error) {
    console.error("Error loading menus:", error);
  }
};
const save = async () => {
  const fields = {
    Title: { value: Obj.value.Title, validators: [isRequired] },
    Message: { value: Obj.value.Message, validators: [isRequired] },
    Menu: { value: Obj.value.Menu, validators: [isRequired] },
  };

  errors.value = validateForm(fields);

  if (Object.keys(errors.value).length === 0) {
    const { url, method, msg } = curdStatus(Obj.value);

    await api[method](`/notifications${url}`, Obj.value)
      .then(() => {
        reset();
        msgObj.value = { msg: `Notification ${msg} Successfuly`, role: "success", show: true, };
        loadData();
      })
      .catch((error) => {
        console.log(error);
      });
  }
};

const reset = async () => {
  Obj.value = { Title: "", Message: "", Menu: "" };
  msgObj.value = { msg: "", role: "", show: false };
  errors.value = {};
};

const progress = ref(0);

const loadData = async () => {
  let direction = 1;
  let progressInterval = setInterval(() => {
    progress.value += direction;
    if (progress.value >= 100) {
      progress.value = 0;
    }
  }, 100);
  if (menus.value.length === 0) {
    await loadmenus();
  }

  await api.get("/notifications/all").then((response) => {
    rows.value = response.data.map((item, i) => {
        const menuName = menus.value.find(m => m.value === item.Menu)?.name || item.Menu;
        return {
          ...item,
          Sno: i + 1,
          Menu: item.Menu,  
          MenuName: menuName, 
        };
      });
    progress.value = 0;
    clearInterval(progressInterval);
  });
};

const delRecord = async () => {
  await api.delete(`/notifications/${delObj.value._id}`)
  .then(() => {
    delObj.value = {};
    loadData();
    msgObj.value = { msg: "Notification Deleted Successfuly.", role: "danger", show: true, };
  });
};

onMounted(() => {
  loadData();
  loadmenus();
});
</script>
